module.exports = __webpack_public_path__ + "img/whs.8d0aff80.jpg";